import {React, useState} from "react";
import { useNavigate } from "react-router-dom";
import { Div, Input, Button, Label } from "./styles/Register-style";
import TaskBarComponent from "./TaskBarComponent";

export default function Register() {

    const navigate = useNavigate();
    const [username, setUserName] = useState('');
    const [useremail, setUserEmail] = useState('');
    const [userpassword, setUserPassword] = useState('');
    const isOnLoginOrRegisterPage = true;

    const handleUserRegistration = async(e) => {
        const userDict = {username: username, useremail: useremail, userpassword: userpassword};
        const  backendURL  = process.env.REACT_APP_BACKEND_URL;
        console.log(backendURL);
        try{
            const response = await fetch(backendURL+'/register', {
                method: 'POST',
                headers : {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userDict)
            });

            if (response.ok) {
                console.log('Data Sent Successfully');
                navigate(`/`);
            } else {
                console.error('Failed to send data');
            }      
        } catch (error) {
            console.error('Error:', error);
        }

    };


  
    return (
        <div className="Register">
            <TaskBarComponent isOnLoginOrRegisterPage={isOnLoginOrRegisterPage}/>
            <Div>
                <Label>Name</Label>
                <Input id="name" name="name" onChange={e => setUserName(e.target.value)} placeholder="Enter Name" /><hr></hr><br></br>
                <Label>Email</Label>
                <Input id="emailAddress" name="emailAddress" onChange={e => setUserEmail(e.target.value)} placeholder="Enter Email Address" /><hr></hr><br></br>
                <Label>Password</Label>
                <Input id="password" name="password" onChange={e => setUserPassword(e.target.value)} placeholder="Enter Password" />
                <Button type='Submit' onClick={handleUserRegistration}>Submit</Button><hr></hr>
            </Div>
        </div>
)};
